import { Component } from '@angular/core';

@Component({
  selector: 'prof-delete-confimation-dialog',
  templateUrl: './delete-confimation-dialog.component.html',
  styleUrl: './delete-confimation-dialog.component.scss',
  standalone: false
})
export class DeleteConfimationDialogComponent {

}
